import { Skeleton } from "antd";

export const LoadingSkeleton: React.FC<{
  width: number;
  loading: boolean;
  style?: React.CSSProperties;
}> = ({ width, loading, style }) => {
  return (
    <div style={style ? style : { marginTop: "6px" }}>
      <Skeleton
        title={false}
        loading={loading}
        paragraph={{ rows: 1, width }}
        active
      />
    </div>
  );
};
